import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DateService {
  now(): Date {
    return new Date();
  }

  thisYear(): number {
    return this.now().getFullYear();
  }
}
